import PubSub from 'underpub-js';
import Masonry from 'masonry-layout';
import gsap from 'gsap';
import ScrollTrigger from 'gsap/ScrollTrigger';

gsap.registerPlugin(ScrollTrigger);

var ListingInsights = function(options) {
  this.options = {
    $el: false,
  };

  this.data = {
    baseClass: 'comp-ListingInsights',
  };

  $.extend(true, this.options, options);
};

ListingInsights.prototype.init = function() {
  const self = this;

  self.$grid = self.options.$el.find(`.${self.data.baseClass}__items`);
  self.data.itemClass = `.${self.data.baseClass}__items__item`;
  self.$item = self.options.$el.find(self.data.itemClass);

  gsap.set(self.$item, {
    opacity: 0,
    y: Math.floor(Math.random() * 70) + 40,
  });

  self.initGrid();
};

ListingInsights.prototype.initGrid = function() {
  const self = this;
  gsap.set(self.$grid, { visibility: 'visible' });

  new Masonry(self.$grid[0], {
    itemSelector: self.data.itemClass,
    transitionDuration: '0.3s',
  });

  self.initScrollAnimation();
};

ListingInsights.prototype.initScrollAnimation = function() {
  const self = this;

  self.$item.each((i, el) => {
    gsap.to(el, {
      scrollTrigger: {
        trigger: el,
        start: 'top bottom',
      },
      duration: Math.floor(Math.random() * 1) + 0.6,
      ease: 'expo.easein',
      delay: 0.2,
      y: 0,
      opacity: 1,
    });
  });
};

export default ListingInsights;
